import React from 'react';
import {Pressable, PressableProps} from 'react-native';
export default function AVTouchableOpacity(props: PressableProps) {
  return (
    <Pressable
      accessibilityLabelledBy={props?.accessibilityLabel}
      accessibilityHint={props?.accessibilityHint}
      accessibilityLabel={props?.accessibilityLabel}
      nativeID={props?.nativeID ?? props?.accessibilityLabel}
      accessibilityRole={'button'}
      {...props}
    />
  );
}
